import firebase from "firebase/compat/app";
import "firebase/compat/auth";

export const auth = firebase
  .initializeApp({
    apiKey: "AIzaSyB0cInheyrcEbVEQGJPa73LJaz1OKDbF6U",
    authDomain: "project8-9bc46.firebaseapp.com",
    projectId: "project8-9bc46",
    storageBucket: "project8-9bc46.appspot.com",
    messagingSenderId: "863599172619",
    appId: "1:863599172619:web:3175be2d97c35690f9fb0e",
  })
  .auth();
